import React from 'react';
import background from '../images/background.png';

function Banner() {
  return (
    <div style={styles.container}>
      <h1 style={{...styles.title, marginTop: '20px'}}>Expert Suppliers of all industrial Adhesive Needs</h1>
      <p style={{ ...styles.tagline, paddingBottom: '30px' }}>Precision Bonding for Every Application</p>
      <a href="tel:9964192505" className="btn btn-outline-light" style={styles.button}>
        Contact Us
      </a>
      <style>
        {`
          @media (max-width: 768px) {
            h1 {
              font-size: 2.7rem !important;
            }
            p {
              font-size: 1.5rem !important;
            }
            button {
              font-size: 0.9rem !important;
              padding: 10px 30px !important;
            }
          }
        `}
      </style>
    </div>
  );
}

const styles = {
  container: {
    backgroundImage: `url(${background})`,    
    backgroundSize: 'cover',
    color: 'white',
    height: '100vh',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
  },
  title: {
    fontSize: '5rem',
    fontWeight: 'bold',
  },
  tagline: {
    fontSize: '2rem',
    margin: '20px 0',
  },
  button: {
    fontSize: '1rem',
    padding: '15px 40px',
    borderRadius: '5px',
    border: '2px solid lightblue',
    boxShadow: '0 0 8px lightblue',
    animation: 'starAnimation 1.5s infinite',
  },
};

export default Banner;
